package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/** Review card: author avatar (initial), name, star rating, optional date, and comment. */
@Composable
fun ReviewCard(
    authorName: String,
    rating: Float,
    comment: String,
    modifier: Modifier = Modifier,
    dateLabel: String? = null,
    // Business owner's public reply (localized label passed by the caller — DS holds no copy).
    ownerReply: String? = null,
    ownerReplyLabel: String? = null,
) {
    Column(
        modifier = modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            Box(
                modifier = Modifier
                    .size(AppTheme.sizes.avatarMd)
                    .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.pill),
                contentAlignment = Alignment.Center,
            ) {
                Text(
                    text = authorName.take(1).uppercase(),
                    style = AppTheme.typography.labelMd,
                    color = AppTheme.colors.onSurface,
                )
            }
            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = authorName,
                    style = AppTheme.typography.labelMd,
                    color = AppTheme.colors.onSurface,
                )
                RatingStars(rating = rating, modifier = Modifier.padding(top = AppTheme.spacing.xxs))
            }
            if (dateLabel != null) {
                Text(
                    text = dateLabel,
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
        }
        Text(
            text = comment,
            style = AppTheme.typography.bodyMd,
            color = AppTheme.colors.onSurfaceVariant,
        )
        if (!ownerReply.isNullOrBlank()) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.md)
                    .padding(AppTheme.spacing.md),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xxs),
            ) {
                if (ownerReplyLabel != null) {
                    Text(
                        text = ownerReplyLabel,
                        style = AppTheme.typography.labelSm,
                        color = AppTheme.colors.primary,
                    )
                }
                Text(
                    text = ownerReply,
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurface,
                )
            }
        }
    }
}
